import gql from 'graphql-tag';

export default gql`
  mutation adminRestoreSite($siteId: ID!) {
    adminRestoreSite(siteId: $siteId) {
      id
    }
  }
`;
